'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _Product = require('../../helpers/Product');

var _stingray_logo_horizontal_white = require('../../../res/images/logo/stingray_logo_horizontal_white.svg');

var _stingray_logo_horizontal_white2 = _interopRequireDefault(_stingray_logo_horizontal_white);

var _Music = require('./Music.scss');

var _Music2 = _interopRequireDefault(_Music);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Music = (_dec = (0, _reactRedux.connect)(function (state) {
  return { appInfo: state.appInfo, auth: state.auth };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Music, _Component);

  function Music() {
    (0, _classCallCheck3.default)(this, Music);
    return (0, _possibleConstructorReturn3.default)(this, (Music.__proto__ || (0, _getPrototypeOf2.default)(Music)).apply(this, arguments));
  }

  (0, _createClass3.default)(Music, [{
    key: 'getLogoElement',
    value: function getLogoElement() {
      var element = null;
      var realm = this.props.auth.realm;
      var product = this.props.auth.productName;
      if (realm === _Product.REALM_NAMES.Stingray && product === _Product.PRODUCT_NAMES.Music) {
        element = _react2.default.createElement(
          'div',
          { className: _Music2.default.logo },
          _react2.default.createElement('img', { src: _stingray_logo_horizontal_white2.default })
        );
      }
      return element;
    }
  }, {
    key: 'getWelcomeClassName',
    value: function getWelcomeClassName() {
      var className = _Music2.default.welcomeMusic;
      if (this.props.auth.isMobile && !this.props.appInfo.excludeHeader) {
        className = className + ' ' + _Music2.default.mobileHeader;
      }
      if (this.props.appInfo.excludeHeader) {
        className = className + ' ' + _Music2.default.excludeHeader;
      }

      return className;
    }
  }, {
    key: 'render',
    value: function render() {
      var segment = this.context.router.location.pathname.split('/')[2] || 'root';
      var logoElement = this.getLogoElement();
      return _react2.default.createElement(
        'div',
        { className: this.getWelcomeClassName() },
        _react2.default.createElement(
          'div',
          { className: _Music2.default.welcomeMusicContent },
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            {
              transitionName: 'fadeInOutMusicLogin',
              transitionEnterTimeout: 300,
              transitionLeaveTimeout: 1
            },
            _react2.default.cloneElement(this.props.children, { key: segment })
          )
        ),
        logoElement
      );
    }
  }]);
  return Music;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  children: _react.PropTypes.object.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired,
  location: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(Music);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Music/Music.js
// module id = 1962
// module chunks = 0